import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid gap-3" }
const _hoisted_2 = { class: "text-sm text-slate-600 dark:text-slate-300" }
const _hoisted_3 = { class: "grid gap-2 sm:grid-cols-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-sm font-semibold" }
const _hoisted_6 = { class: "mt-1 text-xs opacity-75" }

import { MonitorIcon, MoonIcon, SunIcon } from "@lucide/vue"
import { useTheme, type ThemePreference } from "../model/theme"


export default /*@__PURE__*/_defineComponent({
  __name: 'ThemePreferenceControl',
  setup(__props) {

const { themePreference, resolvedTheme, setThemePreference } = useTheme()

const options: Array<{
  value: ThemePreference
  label: string
  description: string
  icon: typeof MonitorIcon
}> = [
  {
    value: "auto",
    label: "Автоматически",
    description: "Использовать тему системы",
    icon: MonitorIcon
  },
  {
    value: "light",
    label: "Светлая",
    description: "Всегда светлый интерфейс",
    icon: SunIcon
  },
  {
    value: "dark",
    label: "Темная",
    description: "Всегда темный интерфейс",
    icon: MoonIcon
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Текущая тема: " + _toDisplayString(_unref(resolvedTheme) === "dark" ? "темная" : "светлая"), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
        return _createElementVNode("button", {
          key: option.value,
          class: _normalizeClass(["min-h-24 rounded-md border p-3 text-left transition focus:outline-none focus:ring-2 focus:ring-blue-500", _unref(themePreference) === option.value
          ? 'border-blue-600 bg-blue-50 text-blue-950 dark:border-blue-400 dark:bg-blue-950/40 dark:text-blue-100'
          : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800']),
          type: "button",
          onClick: ($event: any) => (_unref(setThemePreference)(option.value))
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(option.icon), {
            class: "mb-3 h-5 w-5",
            "aria-hidden": "true"
          })),
          _createElementVNode("div", _hoisted_5, _toDisplayString(option.label), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(option.description), 1)
        ], 10, _hoisted_4)
      }), 64))
    ])
  ]))
}
}

})